module.exports = __webpack_public_path__ + "img/WorkSans-Bold.4ebd646.svg";